import React,{ useState, useEffect } from 'react';
import { Row, Col,Card ,Select} from 'antd';

export default function Home() {
	const [val, setval] = useState('Select');
	const [data, setData] = useState([7,9,3,5,4,2,11,21,22,23,24,25,26,27,28,29,30,31]);

    const onSelect=(e)=>{
        localStorage.setItem("CL",e);
        alert('CL Selected')
    }

  return(
    <>
    <Card>
     <Row>
      <Col span={6} style={{margin:'5px'}}>
       <h1> Choose CL</h1>
      </Col>
      <Col span={6}>
            <Select
                style={{ width: '90%' }}
                placeholder='Select'
                defaultValue={val}
                onChange={onSelect}
                >
                {data.map(elm => <Select.Option key={elm} value={elm}>{elm}</Select.Option>)}
            </Select>
      </Col>
      </Row>
    </Card>
    </>
  );
}